export const goToSelectedPath = {
  redirect(register, event) {
    event.preventDefault()
    if (this.$route.name !== register) {
      if (event.metaKey || event.ctrlKey) {
        const goToSelectedPath = this.$router.resolve({ name: register })
        window.open(goToSelectedPath.href, '_blank')
      } else {
        this.$router.push({ name: register })
      }
    }
  },
}
